import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendRequest,
  requestInProcess,
  requestFinished
} from '../../../../common/reducers/execDeleteMaterialsReducer';

import { deleteChildItems } from '../../../../../../common/reducers/listsCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsMaterials from '../../../../services/TasksExecsMaterials';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

function* deleteExecMaterialById(reducerName, action) {
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsMaterials.deleteExecMaterialById,
      action.payload.materialId
    );
    if (result) {
      if (result.status === 404) {
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'danger',
            message: result.data.message
          })
        );
      } else if (result.status === 204) {
        yield put(
          deleteChildItems(
            'tasksModule.collections.tasksExecsNotSendMaterialsCollection',
            action.payload.execId,
            [action.payload.materialId]
          )
        );
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      deleteExecMaterialById,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/forms/sagas/execDeleteMaterialsFormSaga.js